module.exports = __webpack_public_path__ + "img/case_slide_2.89ad25f5.png";